export default "__VITE_ASSET__9fdc8e26__"